module.exports = __webpack_public_path__ + "img/avatar@2x.97c2ebec.png";